import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';

import { Store } from '@ngrx/store';

import { selectChannelsFilter, selectShowChannelsFilters } from '../../../../store/app.selectors';
import { BaseComponent } from '../../../shared/components/base/base.component';
import { setAllChannelsLoaded, setLoadingChannels, setShowChannelsFilters } from '../../../shared/store/ui.actions';
import { loadChannels, readAllMessages, setChannels, setChannelsFilter, setSearchTerm } from '../../store/chat.actions';
import { AppStateWithChat, chatInitialState } from '../../store/chat.reducer';

@Component({
  selector: 'ngx-channels-list-search',
  templateUrl: './channels-list-search.component.html',
  styleUrls: ['./channels-list-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChannelsListSearchComponent extends BaseComponent implements OnInit {
  @Input() phoneNumber: string;

  private store = inject(Store<AppStateWithChat>);

  channelsFilter = toSignal(this.store.select(selectChannelsFilter), { initialValue: chatInitialState.channelsFilter });
  showFilters = toSignal(this.store.select(selectShowChannelsFilters), { initialValue: false });

  text = '';
  private searchTerm$ = new Subject<string>();

  constructor() {
    super();
    this.addSubscription(
      this.searchTerm$
        .pipe(debounceTime(500), distinctUntilChanged())
        .subscribe((searchText: string) => this.search(searchText))
    );
  }

  ngOnInit() {
    if (this.phoneNumber) {
      this.text = this.phoneNumber;
    }
  }

  onSearchText(value: string): void {
    this.searchTerm$.next(value);
  }

  search(text: string) {
    const channelsFilter = this.channelsFilter();
    this.store.dispatch(setSearchTerm({ searchTerm: text }));
    this.store.dispatch(setChannelsFilter({ filter: { ...channelsFilter, searchTerm: text, page: 1 } }));
    this.store.dispatch(setLoadingChannels({ value: true }));
    this.store.dispatch(setAllChannelsLoaded({ value: false }));
    this.store.dispatch(setChannels({ channels: [], concat: false }));
    this.store.dispatch(
      loadChannels({
        autoSelectChannel: false,
        setLoading: true,
        concat: false,
      })
    );
  }

  setShowFilters(): void {
    this.store.dispatch(setShowChannelsFilters({ value: !this.showFilters() }));
  }

  readAllMessages(): void {
    this.store.dispatch(readAllMessages());
  }
}
